import React from 'react';

import { Stack } from '@mui/material';
import {
  PLAYER_EMAIL_MAX_LENGTH,
  PLAYER_EMAIL_MIN_LENGTH
} from 'constants/constants';

import { OrderFilterKey } from '../constant';

import {
  ClearFiltersButton,
  DateFilter,
  DeviceOSFilter,
  StatusFilter
} from './filters';
import { FreeSearchFilter } from './filters/FreeSearchFilter';
import { ProjectFilter } from './filters/ProjectFilter';

interface OrdersFilterBarProps {
  isFree?: boolean;
  clearFiltersButton: boolean;
  handleClearFilters: () => void;
  selectedProjects: string[];
  setSelectedProjects: (projects: string[]) => void;
  appliedProjects: string;
  handleUpdateParam: (paramName: string, paramValue: string) => void;
  handleUpdateDateParams: (startDate: string, endDate: string) => void;
}

const OrdersFilterBarComponent: React.FC<OrdersFilterBarProps> = ({
  isFree,
  clearFiltersButton,
  handleClearFilters,
  selectedProjects,
  setSelectedProjects,
  appliedProjects,
  handleUpdateParam,
  handleUpdateDateParams
}) => {
  return (
    <Stack
      direction="row"
      gap={1}
      sx={{ alignItems: 'center', flexWrap: 'wrap' }}
    >
      {isFree ? (
        <>
          <DateFilter handleUpdateDateParams={handleUpdateDateParams} />
          <FreeSearchFilter
            label="Transaction ID"
            filterKey={OrderFilterKey.PUBLISHER_PURCHASE_ID}
            handleUpdateParam={handleUpdateParam}
          />
          <FreeSearchFilter
            label="Player ID"
            filterKey={OrderFilterKey.PLAYER_ID}
            handleUpdateParam={handleUpdateParam}
          />
          <FreeSearchFilter
            label="Order ID"
            filterKey={OrderFilterKey.ORDER_ID}
            handleUpdateParam={handleUpdateParam}
          />
          <DeviceOSFilter
            selectedProjects={appliedProjects}
            handleUpdateParam={handleUpdateParam}
          />
          <StatusFilter
            isFree={isFree}
            selectedProjects={appliedProjects}
            handleUpdateParam={handleUpdateParam}
          />
        </>
      ) : (
        // Paid Orders filters
        <>
          <ProjectFilter
            selectedProjects={selectedProjects}
            setSelectedProjects={setSelectedProjects}
            dataTestId="projectFilter"
          />
          <DateFilter handleUpdateDateParams={handleUpdateDateParams} />
          <FreeSearchFilter
            label="Player ID"
            filterKey={OrderFilterKey.PLAYER_ID}
            handleUpdateParam={handleUpdateParam}
          />
          <FreeSearchFilter
            label="Player Email"
            filterKey={OrderFilterKey.PLAYER_EMAIL}
            handleUpdateParam={handleUpdateParam}
            minLength={PLAYER_EMAIL_MIN_LENGTH}
            maxLength={PLAYER_EMAIL_MAX_LENGTH}
          />
          <FreeSearchFilter
            label="Order ID"
            filterKey={OrderFilterKey.ORDER_ID}
            handleUpdateParam={handleUpdateParam}
          />
          <FreeSearchFilter
            label="Transaction ID"
            filterKey={OrderFilterKey.PUBLISHER_PURCHASE_ID}
            handleUpdateParam={handleUpdateParam}
          />
          <FreeSearchFilter
            label="Receipt number"
            filterKey={OrderFilterKey.RECEIPT_ID}
            handleUpdateParam={handleUpdateParam}
          />
          <DeviceOSFilter
            selectedProjects={appliedProjects}
            handleUpdateParam={handleUpdateParam}
          />
          <StatusFilter
            isFree={isFree}
            selectedProjects={appliedProjects}
            handleUpdateParam={handleUpdateParam}
          />
        </>
      )}
      {clearFiltersButton && (
        <ClearFiltersButton onClick={handleClearFilters} />
      )}
    </Stack>
  );
};

export const OrdersFilterBar = React.memo(OrdersFilterBarComponent);

OrdersFilterBar.displayName = 'OrdersFilterBar';
